import React, { ChangeEvent, ReactChild, useMemo } from "react"

/*
    チェックボックスを生成するコンポーネント
    props
        values:{
            label:
            value:
            id:
            notice:
        }の配列
        selected:選択状態のidを配列型で受け取る。選択がない場合はNullを。
 */

interface Value {
  label: string,
  value?: string | number,
  checked?: boolean,
  notice?: string,
}

interface Props {
  value: Value,
  name: string,
  children?: ReactChild | ReactChild[],
  onChange?: (checked: boolean) => void,
  isGroup?: Boolean,
  className?: string
}

function CheckBoxSingle({ value, name, onChange, className = "" }: Props) {
  const id = useMemo(() => `checkbox-${name}`, [name])
  return (
    <div className={"form-check custom-control custom-checkbox"}>
      <input
        id={id}
        className={`custom-control-input ${className}`} type="checkbox"
        checked={value.checked}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          onChange && onChange(e.target.checked)
        }}
      />
      <label className="custom-control-label" onClick={() => {
        onChange && onChange(!value.checked)
      }}>
        <span>{value.label}</span>{value.notice && <><br /><span className="text-s">{value.notice}</span></>}
      </label>
    </div>
  )
}

export function CheckBox(props: Props) {
  const { value, name, children, onChange, isGroup = true, className = "" } = props

  if (isGroup) {
    return (
      <div className="checkbox-area">
        <div className="form-group">
          <CheckBoxSingle
            value={value}
            name={name}
            onChange={onChange}
            className={className}
          />
        </div>
        <>{children}</>
      </div>
    )
  }

  return (
    <CheckBoxSingle
      value={value}
      name={name}
      onChange={onChange}
      className={className}
    />
  )
}